import { useQuery } from '@tanstack/react-query';

import { fetchKarmaTotal } from '../api/fetchKarmaTotal';
import { karmaKeys } from './keys';

export function useKarmaTotalQuery(days?: number) {
  return useQuery({
    queryKey: karmaKeys.total(days),
    queryFn: ({ signal }) => fetchKarmaTotal(days, signal),
    staleTime: 30_000,
  });
}
